import { Spin } from 'antd';
import { useParams } from 'react-router';
import {
  LoyaltySettingProductDetails,
  useFetchMcProductDetails,
} from '../../../../services/MySubmissions';
import useSetBreadCrumbParams from '../../../../hooks/useSetBreadCrumbParams';
import { dateOrDash, valueOrDash } from '../../../../utils/utilFunctions';
import { PageHeaderWithBackButton } from '../../../../components/common';
import CardSection from '../../../../components/CardSection';
import { DisplayMarkdownOrDash } from '../../helpers';

const StampCardSubmissionsDetailsView = () => {
  const { id } = useParams();
  const stampCardId = String(id);

  const { data: stampCardSubmissionsData, isFetching } =
    useFetchMcProductDetails({
      id: stampCardId,
    });

  const isNotEmpty = stampCardSubmissionsData !== undefined;

  useSetBreadCrumbParams(
    [
      {
        label: `${String(
          stampCardSubmissionsData?.company?.name,
        )} (Stamp Card Detail)`,
        key: String(id),
      },
    ],
    isNotEmpty,
  );

  const productDetails =
    stampCardSubmissionsData?.product_details as LoyaltySettingProductDetails;

  const basicDetails = [
    {
      key: '1',
      label: 'Minimum Spending Amount',
      children: valueOrDash(productDetails?.min_spending_amount_humanize),
    },
    {
      key: '2',
      label: 'Total Stamps',
      children: valueOrDash(productDetails?.total_stamps_count),
    },
  ];

  const expiryDetails = [
    {
      key: '1',
      label: 'Start Date',
      children: dateOrDash(productDetails?.start_date),
    },
    {
      key: '2',
      label: 'End Date',
      children: dateOrDash(productDetails?.end_date),
    },
    {
      key: '3',
      label: 'Duration',
      children: valueOrDash(productDetails?.duration),
    },
  ];

  const finePrintDetails = [
    {
      key: '1',
      label: 'Fine Print',
      children: <DisplayMarkdownOrDash text={productDetails?.fine_print} />,
    },
    {
      key: '2',
      label: 'Description',
      children: <DisplayMarkdownOrDash text={productDetails?.description} />,
    },
  ];

  const rewardDetails = productDetails?.loyalty_rewardable_settings?.map(
    (reward, index) => [
      {
        key: `1-${index}`,
        label: 'Stamp Number',
        children: valueOrDash(reward.required_stamps_count),
      },
      {
        key: `2-${index}`,
        label: 'Reward Name',
        children: valueOrDash(reward?.rewardable_details?.name),
      },
      {
        key: `3-${index}`,
        label: 'Reward Description',
        children: (
          <DisplayMarkdownOrDash
            text={reward?.rewardable_details?.description}
          />
        ),
      },
      {
        key: `4-${index}`,
        label: 'Redemption Start Date',
        children: dateOrDash(reward?.rewardable_details?.redemption_start_date),
      },
      {
        key: `5-${index}`,
        label: 'Redemption End Date',
        children: dateOrDash(reward?.rewardable_details?.redemption_end_date),
      },
      {
        key: `6-${index}`,
        label: 'Validity Days',
        children: valueOrDash(reward?.rewardable_details?.validity_days),
      },
      {
        key: `7-${index}`,
        label: 'What You Get',
        children: (
          <DisplayMarkdownOrDash
            text={reward?.rewardable_details?.what_you_get}
          />
        ),
      },
      {
        key: `8-${index}`,
        label: 'Fine Print',
        children: (
          <DisplayMarkdownOrDash
            text={reward?.rewardable_details?.fine_print}
          />
        ),
      },
      {
        key: `9-${index}`,
        label: 'Redemption Instructions',
        children: (
          <DisplayMarkdownOrDash
            text={reward?.rewardable_details?.redemption_instructions}
          />
        ),
      },
      {
        key: `10-${index}`,
        label: 'Reward Image(s)',
        children: reward?.rewardable_details?.image_urls?.map((url, index) => (
          <div key={index}>
            {url ? (
              <div>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
                <img src={url} alt="Reward Image" />
              </div>
            ) : (
              valueOrDash(url)
            )}
          </div>
        )),
      },
    ],
  );

  const sections = [
    {
      key: '1',
      title: 'Basic Details',
      data: basicDetails,
    },
    {
      key: '2',
      title: 'Expiry Details',
      data: expiryDetails,
    },
    {
      key: '3',
      title: 'Fine Print Details',
      data: finePrintDetails,
    },
  ];

  return (
    <div>
      <PageHeaderWithBackButton
        title={valueOrDash(stampCardSubmissionsData?.company?.name)}
        subTitle={'Stamp Card Detail'}
      />
      <Spin spinning={isFetching} style={{ width: '100%' }}>
        {sections.map(({ key, ...restItems }) => (
          <CardSection key={key} sectionNumber={key} {...restItems} />
        ))}
        {rewardDetails?.map((reward, index) => (
          <CardSection
            key={index}
            sectionNumber={`4-${index}`}
            title={`Reward ${index + 1}`}
            data={reward}
          />
        ))}
      </Spin>
    </div>
  );
};

export default StampCardSubmissionsDetailsView;
